








import { SfBadge } from '@storefront-ui/vue';
import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'Chip',
  components: {
    SfBadge
  },
  props: {
    item: {
      type: Object,
      required: true,
      default() {
        return {
          name: 'Chip title',
          id: 1
        };
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
});
